export const FIRMWARE_FEATURE_CHIP_IDS = ["N", "B", "W", "W-HC", "Q"] as const;

export type FirmwareFeatureChipId = (typeof FIRMWARE_FEATURE_CHIP_IDS)[number];

function isFirmwareFeatureChipId(value: string): value is FirmwareFeatureChipId {
  return (FIRMWARE_FEATURE_CHIP_IDS as readonly string[]).includes(value);
}

/** N-B is two chips (N or B). W-HC is one chip, colored differently from W. */
export function firmwareFeatureChipIds(feature: string | null): FirmwareFeatureChipId[] {
  if (feature == null) return [];
  if (feature === "N-B") return ["N", "B"];
  if (isFirmwareFeatureChipId(feature)) return [feature];
  return [];
}
